module.exports = new __parcel__URL__("RightArrow.b920000b.svg").toString();